import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
interface TermsPageProps {
  onNavigate?: (path: string) => void;
}
export function TermsPage({
  onNavigate
}: TermsPageProps) {
  return <div className="min-h-screen bg-[#f5f5f7] text-[#1f2933]" data-id="element-1703">
      <Navbar onNavigate={onNavigate} data-id="element-1704" />

      <section className="py-24" data-id="element-1705">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-1706">
          <h1 className="text-4xl font-bold mb-8" data-id="element-1707">Terms of Service</h1>
          <p className="text-sm text-[#9ca3af] font-mono mb-12" data-id="element-1708">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 bg-white border-2 border-dashed border-[#9ca3af] p-8" data-id="element-1709">
            <section data-id="element-1710">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1711">1. Agreement to Terms</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1712">
                By accessing The Authority Engine program, you agree to be bound
                by these Terms of Service and all applicable laws and
                regulations. If you do not agree with any of these terms, you
                are prohibited from using or accessing this program.
              </p>
            </section>

            <section data-id="element-1713">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1714">2. Program Access</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1715">
                Upon payment, you will receive lifetime access to The Authority
                Engine program materials, including all 10 core modules,
                accountability pod membership, and community access.
              </p>
              <p className="text-[#1f2933]/80" data-id="element-1716">
                The program runs for 2 months with weekend sessions (Sunday
                evenings). Session times may be adjusted based on community
                consensus.
              </p>
            </section>

            <section data-id="element-1717">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1718">3. Payment Terms</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1719">
                The program fee is ₦35,000 (early bird rate, 50% off) until
                January 31st, 2026. After this date, the standard rate of
                ₦70,000 applies. All payments are processed securely through
                Selar.
              </p>
              <p className="text-[#1f2933]/80" data-id="element-1720">
                Payments are non-refundable after 7 days of program
                commencement.
              </p>
            </section>

            <section data-id="element-1721">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1722">
                4. Intellectual Property
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1723">
                All program materials, including but not limited to course
                content, templates, frameworks, and resources, are the
                intellectual property of The Networking Salon Ltd. You may not
                reproduce, distribute, or create derivative works without
                explicit written permission.
              </p>
            </section>

            <section data-id="element-1724">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1725">5. User Conduct</h2>
              <p className="text-[#1f2933]/80 mb-4" data-id="element-1726">
                Participants are expected to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-[#1f2933]/80" data-id="element-1727">
                <li data-id="element-1728">
                  Engage respectfully with fellow participants and facilitators
                </li>
                <li data-id="element-1729">
                  Maintain confidentiality of shared information within pods
                </li>
                <li data-id="element-1730">Attend scheduled sessions and complete assignments</li>
                <li data-id="element-1731">Provide constructive feedback to peers</li>
              </ul>
            </section>

            <section data-id="element-1732">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1733">
                6. Limitation of Liability
              </h2>
              <p className="text-[#1f2933]/80" data-id="element-1734">
                The Authority Engine provides educational content and systems.
                Results may vary based on individual effort, market conditions,
                and other factors. We make no guarantees of specific outcomes or
                income levels.
              </p>
            </section>

            <section data-id="element-1735">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1736">7. Modifications</h2>
              <p className="text-[#1f2933]/80" data-id="element-1737">
                We reserve the right to modify these terms at any time.
                Participants will be notified of significant changes via email
                or community announcements.
              </p>
            </section>

            <section data-id="element-1738">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1739">8. Contact</h2>
              <p className="text-[#1f2933]/80" data-id="element-1740">
                For questions about these Terms of Service, please contact us
                through our community WhatsApp group or email support.
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer onNavigate={onNavigate} data-id="element-1741" />
    </div>;
}